import { useThemeMode } from '../../context/contextTheme';
import { useTSContext } from '../../context/Dashboard/contextTScore';
import { ResponsiveContainer, PieChart, Pie, Legend } from 'recharts';

const PieChartGraph = () => {
  const { theme } = useThemeMode();
  const { pieData, hasAssets } = useTSContext();
  const renderCustomizedLabel = ({ name, value }) => `${name}: ${value}`;
  const filteredPieData = pieData.filter((data) => data.value > 0);
  
  return (
    <div className="p-2 mb-3">
      <div
        className="card rounded-4 shadow-sm"
        style={{ 
          width: '100%', height: 400, 
          backgroundColor: theme.background,
          border: `1px solid ${theme.border}`
        }}>
        <div className="card-body">
          <h6 className="card-title fw-semibold text-center mt-4" 
            style={{ fontSize: 20, color: theme.textColor }}>
            Vulnerability Distribution
          </h6>
          {!hasAssets ? (
            <div className="h-75 d-flex flex-column justify-content-center align-items-center">
              <p className="fs-6 fw-semibold text-muted mt-2">
                Initiated the scan to get the pie data.
              </p>
            </div>
          ) : pieData.length === 0 ? (
              <div className="h-75 d-flex flex-column justify-content-center align-items-center rounded-4" 
                style={{ backgroundColor: theme.background2, color: theme.textMuted }}>
                <i className="bi bi-shield-fill-check fs-1"></i>
                <p className="fw-semibold mt-2">
                  No vulnerabilities detected. Pie data is not available.
                </p>
              </div>
            ) : (
              <div className="p-2">
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={filteredPieData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      innerRadius={80}
                      outerRadius={100}
                      label={renderCustomizedLabel}
                    />
                    <Legend
                      iconSize={10}
                      layout="vertical"
                      verticalAlign="middle"
                      align="right"
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default PieChartGraph;